"use strict";
/*
 * Created on 21. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ResultSeverity_1 = require("../../../core/model/errors/ResultSeverity");

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");

var FlagSet_1 = require("../../../core/model/FlagSet");

var ReleaseItemValidationKey_1 = require("../../../release/model/alerts/ReleaseItemValidationKey");

var RequiresRecalculation_1 = require("../../../release/model/alerts/RequiresRecalculation");
/**
 * Product deactivated event.
 * @author Radek Beran
 */


var ProductDeactivated =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(ProductDeactivated, _EntityEventFlag_1$En);

  function ProductDeactivated() {
    _classCallCheck(this, ProductDeactivated);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductDeactivated).apply(this, arguments));
  }

  _createClass(ProductDeactivated, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return ProductDeactivated;
}(EntityEventFlag_1.EntityEventFlag);

exports.ProductDeactivated = ProductDeactivated;
ProductDeactivated.TAG = EntityEventFlag_1.EntityEventFlag.register(ProductDeactivated);
ProductDeactivated.INSTANCE = new ProductDeactivated();
ProductDeactivated.MESSAGE = new ValidationResultObject_1.ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, ReleaseItemValidationKey_1.ReleaseItemMessageCode.ProductDeactivated, immutable_1.List.of(), null, null, FlagSet_1.FlagSet.of(ValidationResultFlag_1.ValidationResultFlag, RequiresRecalculation_1.RequiresRecalculation.INSTANCE));